import React from "react";
import "./Our_objective.css";
import Common_title from "../../common-components/common-title/Common_title";

const Our_objective = () => {
  return (
    <>
      <section className="Our_Objectives">
        <div className="common_title_div">
          <Common_title title="OBJECTIVES" subtitle="Our Objectives" />
        </div>

        <div className="container">
          <div className="bg_img_holder">
            <img
              src={
                process.env.PUBLIC_URL +
                "/assets/images/about-us/our-objective/m1.png"
              }
              className="bg_img"
              alt="Fruits Background"
            />

            <div className="content_div">
              <div className="row">
                {/* Vision */}
                <div className="col-md-6 ">
                  <div className="white_card">
                    <div className="logo_img_holder">
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/images/about-us/our-objective/vision.png"
                        }
                        className="logo_img"
                        alt="Vision Icon"
                      />
                    </div>
                    <p className="title">Our Vision</p>
                    <p className="dsecn">
                      Our vision is to revolutionize the digital retail
                      landscape by making everyday shopping effortless,
                      transparent, and rewarding for everyone. We aim to
                      challenge the status quo of online shopping by bringing
                      together premium fashion, footwear, watches, and
                      cutting-edge electronics into one seamless platform. By
                      setting new standards in product authenticity,
                      lightning-fast fulfillment, and customer-first service, we
                      aspire to be the most trusted e-commerce ecosystem—where
                      quality meets convenience at the tap of a button.
                    </p>
                  </div>
                </div>

                {/* Mission */}
                <div className="col-md-6 ">
                  <div className="white_card">
                    <div className="logo_img_holder">
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/images/about-us/our-objective/mission.png"
                        }
                        className="logo_img"
                        alt="Mission Icon"
                      />
                    </div>
                    <p className="title">Our Mission</p>
                    <p className="dsecn">
                      At GeeCart, our mission is to make premium lifestyle,
                      fashion, and technology accessible to everyone with total
                      trust and convenience. We curate 100% authentic products
                      from leading global brands to ensure you always get
                      top-tier quality at unbeatable prices. By leveraging fast
                      delivery networks, seamless app navigation, and
                      hassle-free returns, we eliminate every friction point
                      from your shopping experience. We hold ourselves to
                      absolute standards of customer satisfaction so you can
                      shop with complete peace of mind. Every product we deliver
                      is designed to elevate your everyday life effortless
                      shopping is just a tap away.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Our_objective;
